<template>
  <div class="sp-template tms-index__page">
    <el-row :gutter="20">
      <!-- <el-col :span="7">
        <el-card class="box-card" style="margin:0">
          <h2>{{dateTime}}
            <span>{{week}}</span>
          </h2>
          <h2 class="m-t">你好！
            <span v-if="userName">{{userName}}</span>
          </h2>
          <p>所属公司：{{orgName}}</p>
          <p>{{customerNumber}}</p>
        </el-card>
      </el-col> -->
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <el-row align="middle" style="padding:0 auto;">
          <!-- <el-col :span="d.icon == 'icon-yue' ? 10 : 9" v-for="(d, i) in styleArr" :key="i"> -->
          <!-- <el-col :md="4" v-for="(d, i) in styleArr" :key="i" style="margin-left: 20px;"> -->

            <div v-for="(d, i) in styleArr" :key="i"  @click="handleChartData(i)" class="f-box" style="margin-left:10px;width: 150px;height:182px;cursor:pointer;float:left;margin-bottom:10px;box-shadow: 0 1px 2px rgba(0,0,0,.2);background-color: #fff;" >
              <div class="f-img">
                <div class="f-img-bg" :class="d.bg" style="width: 100px !important;height:100px;">
                  <i class="iconfont" :class="d.icon"></i>
                </div>
              </div>

              <div class="f-c-box" style="width: 150px;float:left;">
                <div class="" style="text-align: center;font-size: 10px;" >
                  <span>{{d.text}}</span>
                  <h1>
                    <span v-if="d.icon == 'icon-yue'">¥&nbsp;</span>                    
                    {{cardArr[i]}}</h1>                  
                </div>
              </div>
            </div>

          <!-- </el-col> -->
          <!-- 目标货量 -->
          <el-form label-width="120px" style="clear:both;">
            <el-row>
              <div style="display: inline-block;margin-left:10px;">
                <span style="font-size: 14px;color: #606266;line-height: 40px;">
                  本月目标货量：
                </span>
                <span style="font-weight:700;font-size:18px;color:red;">{{todayData.goalWeigth}}</span>
              </div>
              <div style="display: inline-block;margin-left:10px;">
                <span style="font-size: 14px;color: #606266;line-height: 40px;">
                  本月完成货量：
                </span>
                <span style="font-weight:700;font-size:18px;color:red;">{{todayData.doneWeigth}}</span>
              </div>
              <div style="display: inline-block;margin-left:10px;">
                <span style="font-size: 14px;color: #606266;line-height: 40px;">
                  本月完成比例：
                </span>
                <span style="font-weight:700;font-size:18px;color:red;">{{todayData.goalRate}}</span>
              </div>

            </el-row>
          </el-form>

          <!-- 柱状图 -->
          <div class="el-table el-table--enable-row-hover el-table--medium" style="width: 100%;">
            <div ref="commandstats" style="height: 420px" />
          </div>
          
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-tabs v-model="activeTab" type="border-card" class="bulletin-tab">
          <el-tab-pane label="系统公告" name="bulletin">
            <span slot="label">
              <i class="unread-item" v-if="unreadNoticeTotal > 0">{{unreadNoticeTotal}}</i> 系统公告
            </span>
            <div class="tab-content">
              <div class="content-title clearfix">
                <span class="tips-text">共
                  <b class="number">{{noticeTotal}}</b>条，其中
                  <router-link class="new" tag="a" :to="{path:'/bulletins',query:{status:3}}" title="点击查看未读公告">未读公告</router-link>
                  <b class="number">{{unreadNoticeTotal}}</b>条
                </span>
                <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/bulletins',query:{status:1}}">查看全部 >></router-link>
              </div>
              <ul class="news-list">
                <a href="#" v-for="item in unreadNoticeList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
                <a href="#" v-for="item in readNoticeList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="最新消息" name="message">
            <span slot="label">
              <i class="unread-item" v-if="unreadMessageTotal > 0">{{unreadMessageTotal}}</i> 最新消息
            </span>
            <div class="tab-content">
              <div class="content-title clearfix">
                <span class="tips-text">共
                  <b class="number">{{messageTotal}}</b>条，其中
                  <router-link class="new" tag="a" :to="{path:'/message',query:{status:3}}" title="点击查看未读消息">未读消息</router-link>
                  <b class="number">{{unreadMessageTotal}}</b>条
                </span>
                <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/message',query:{status:1}}">查看全部 >></router-link>
              </div>
              <ul class="news-list">
                <a href="#" v-for="item in unreadMessageList" :key="item.id" @click.prevent="checkNoticeInfo('MESSAGE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <!-- <i class="new-gif__icon"></i> -->
                    <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
                <a href="#" v-for="item in readMessageList" :key="item.id" @click.prevent="checkNoticeInfo('MESSAGE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="更新报价" name="pricelist">
            <span slot="label">
              <i class="unread-item" v-if="unreadQuotationTotal > 0">{{unreadQuotationTotal}}</i> 更新报价
            </span>
            <div class="tab-content">
              <div class="content-title clearfix">
                <span class="tips-text">共
                  <b class="number">{{quotationTotal}}</b>条，其中
                  <router-link class="new" tag="a" :to="{path:'/quotation',query:{status:3}}" title="点击查看最新报价">最新报价</router-link>
                  <b class="number">{{unreadQuotationTotal}}</b>条
                </span>
                <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/quotation',query:{status:1}}">查看全部 >></router-link>
              </div>
              <ul class="news-list">
                <a href="#" v-for="item in unreadQuotationList" :key="item.id" @click.prevent="checkNoticeInfo('QUOTATION',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list update-price__list">
                    <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                    <span class="item-title">{{item.title}}</span>
                    <i class="iconfont icon-xiazai download-file__btn" title="下载" v-if="item.quotationNoticeValues && item.quotationNoticeValues.length === 1" @click.stop="quotationDownload(item.quotationNoticeValues[0].quotationUrl)"></i>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
                <a href="#" v-for="item in readQuotationList" :key="item.id" @click.prevent="checkNoticeInfo('QUOTATION',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list update-price__list">
                    <span class="item-title">{{item.title}}</span>
                    <i class="iconfont icon-xiazai download-file__btn" title="下载" v-if="item.quotationNoticeValues && item.quotationNoticeValues.length === 1" @click.stop="quotationDownload(item.quotationNoticeValues[0].quotationUrl)"></i>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="系统信息" name="systeminfo">
            <span slot="label">
              <i class="unread-item" v-if="unreadSystemInfoTotal > 0">{{unreadSystemInfoTotal}}</i> 系统信息
            </span>
            <div class="tab-content">
              <div class="content-title clearfix">
                <span class="tips-text">(共
                  <b class="number">{{systemInfoTotal}}</b>条，其中
                  <router-link class="new" tag="a" :to="{path:'/systeminfo',query:{status:3}}" title="点击查看未读公告">未读系统信息</router-link>
                  <b class="number">{{unreadSystemInfoTotal}}</b>条)
                </span>
                <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/systeminfo',query:{status:1}}">查看全部 >></router-link>
              </div>
              <ul class="news-list">
                <a href="#" v-for="item in unreadSystemInfoList" :key="item.id" @click.prevent="checkNoticeInfo('SYSTEMINFO',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
                <a href="#" v-for="item in readSystemInfoList" :key="item.id" @click.prevent="checkNoticeInfo('SYSTEMINFO',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
                  <li class="list">
                    <span class="item-title">{{item.title}}</span>
                    <small class="small">{{item.createDate}}</small>
                  </li>
                </a>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- 通知-弹层 -->
    <el-dialog :title="title" :visible.sync="dialogNoticeVisible" append-to-body width="30%">
      <div class="dialog-content">
        <span class="title">标题：</span>
        <span class="content">{{checkNotice.title}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">优先级：</span>
        <span class="content">{{checkNotice.level == 1 ? "紧急" : "一般"}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">发布公司：</span>
        <span class="content">{{checkNotice.orgOp}}</span>
      </div>
      <div class="dialog-content" v-if="checkNotice.quotationNoticeValues && checkNotice.quotationNoticeValues.length > 0">
        <span class="title">最新报价：</span>
        <span class="content">
          <a class="content-price__download" :href="item.quotationUrl" v-for="(item, index) in checkNotice.quotationNoticeValues" :key="index" title="点击下载报价单">
            {{customerTypeMap[item.customerType]}}
          </a>
        </span>
      </div>
      <div class="dialog-content">
        <span class="title">发布时间：</span>
        <span class="content">{{checkNotice.createDate}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">内容：</span>
        <span class="content text-content ql-editor" v-html="checkNotice.content"></span>
      </div>
    </el-dialog>
    <!-- 紧急通知-弹层 -->
    <el-dialog title="紧急通知" :visible.sync="dialogUrgentVisible" append-to-body width="30%" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <div class="dialog-content">
        <span class="title">标题：</span>
        <span class="content">{{noticeData[0].title}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">类型：</span>
        <span class="content">{{noticeData[0].type == "NOTICE" ? "系统公告" : "最新消息"}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">发布公司：</span>
        <span class="content">{{noticeData[0].orgOp}}</span>
      </div>
      <div class="dialog-content" v-if="noticeData[0].quotationNoticeValues && noticeData[0].quotationNoticeValues.length > 0">
        <span class="title">最新报价：</span>
        <span class="content">
          <a class="content-price__download" :href="item.quotationUrl" v-for="(item, index) in noticeData[0].quotationNoticeValues" :key="index" title="点击下载报价单">
            {{customerTypeMap[item.customerType]}}
          </a>
        </span>
      </div>
      <div class="dialog-content">
        <span class="title">发布时间：</span>
        <span class="content">{{noticeData[0].createDate}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">内容：</span>
        <span class="content text-content ql-editor" v-html="noticeData[0].content"></span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createdReadNotice(noticeData[0].id,'URGENT_NOTICE')">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import echarts from "echarts";

export default {
  data() {
    return {
      screenWidth: document.body.clientWidth, //监听浏览器宽度，为了图表适应
      chart: null,
      title: "",
      dateTime: "",
      week: "",
      loginInfo: {},
      orgName: "",
      userName: "",
      customerNumber: "",
      activeTab: "bulletin",
      flag: false,
      cardArr: [0, 0, 0, 0, 0],
      styleArr: [
        {
          bg: "bg-c",
          icon: "icon-sh-num",
          text: "今日新建订单量"
        },
        {
          bg: "bg-b",
          icon: "icon-sh-weight",
          text: "今日入仓订单量"
        },
        {
          bg: "bg-o",
          icon: "icon-ch-num",
          text: "今日入仓重量"
        },
        {
          bg: "bg-b",
          icon: "icon-ch-weight",
          text: "今日发货客户数"
        },
        {
          bg: "bg-b",
          icon: "icon-yue",
          text: "今日销售金额"
        }
      ],
      noticeData: [
        {
          content: "",
          createDate: "",
          id: "",
          level: 1,
          orgOp: "",
          title: "",
          type: "",
          isRead: false
        }
      ],
      customerTypeList: [],
      customerTypeMap: {},
      currentPage: 1,
      pageSize: 10,
      status: 2,

      systemInfoTotal:0,
      unreadSystemInfoTotal:0,
      unreadSystemInfoList:[],
      readSystemInfoList:[],

      noticeTotal: 0,
      unreadNoticeTotal: 0,
      unreadNoticeList: [],
      readNoticeList: [],
      messageTotal: 0,
      unreadMessageTotal: 0,
      unreadMessageList: [],
      readMessageList: [],
      quotationTotal: 0,
      unreadQuotationTotal: 0,
      unreadQuotationList: [],
      readQuotationList: [],
      checkNotice: "",
      dialogNoticeVisible: false,
      dialogUrgentVisible: false,
      dataType: {
        'today': '新建订单量',
        'order1': '新建订单量',
        'order2': '入仓订单量',
        'weight': '入仓重量',
        'customer': '发货客户数',
        'amount': '销售金额'
      },
      colorType: {
        'today': '#9FE6B8',
        'order1': '#9FE6B8',
        'order2': '#32C5E9',
        'weight': '#ff9f7f',
        'customer': '#E690D1',
        'amount': '#FFDB5C'
      },
      todayData: {}
    };
  },
  components: {},
  created() {
    setInterval(() => {
      this.getTime();
    });
    setTimeout(() => {
      let currentOrg = sessionStorage.getItem("currentOrg");
      if (currentOrg !== undefined && currentOrg !== null) {
        this.getCustomerType()
        // this.queryUserInfo();
        this.queryTodayOrders('today');


        // this.queryUrgentNotice(); // 通知
        this.queryNotice();
        this.queryMessage();
        this.querySystemInfo();
        this.queryQuotationNotice();
      }
    }, 1000);
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      this.chart = echarts.init(this.$refs.commandstats);
    })
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        _this.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
    // 监听窗口宽度，重置图表尺寸
    screenWidth: {
      deep: true,
      immediate: false,
      handler(newVal,oldVal) {
        // console.log(newVal, this.chart)
        // 图标宽度适应
        if(this.chart!=null){
          this.chart.resize()
        }        
      }
    }
  },
  methods: {
    initChart(dates, data, type, color  ) {
      this.chart.setOption({
        title: {
          text: '近一个月统计'
        },
        tooltip: {},
        legend: {
          data: [type]
        },
        xAxis: {          
          axisLabel: {
              interval:0,
              rotate:50,
              textStyle: { //数值样式
                // color: '#1392ff',
                fontSize: 12
              }
          },
          boundaryGap: true,
          type: 'category',
          data: dates
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        yAxis: {},
        series: [
          {
            name: type,
            type: 'bar',
            data: data,
            itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: 'black',
										fontSize: 10
									}
								}
							}
						},
            color: [color]
            // color: ['#73b9bc'] // 绿蓝
            // color: [
            //   // '#37A2DA', // 蓝
            //   // '#32C5E9', // 浅蓝
            //   // '#67E0E3', // 浅蓝
            //   '#9FE6B8', // 浅绿
            //   '#FFDB5C', // 浅黄
            //   '#ff9f7f', // 橙
            //   '#fb7293', // 红
            //   '#E062AE', // 紫
            //   '#E690D1', // 浅紫
            //   '#e7bcf3', // 淡紫
            //   '#9d96f5', // 紫
            //   '#8378EA', // 深紫
            //   '#96BFFF' // 浅蓝
            // ]
          }
        ]
      });
    },
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    quotationDownload(url) {
      this.$windowOpen1(url);
    },
    queryUserInfo() {
      this.$request1({
        method: 'GET',
        url: '/home/user'
      })
        .then(response => {
          let data = response.data.data;
          this.orgName = data.orgName;
          this.userName = data.userName;
          this.customerNumber = data.customerNumber;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 选择图表
    handleChartData(i){
      if(i ==0 ){
        this.queryTodayOrders('order1')
      }else if(i ==1 ){
        this.queryTodayOrders('order2')
      }else if(i ==2 ){
        this.queryTodayOrders('weight')
      }else if(i ==3 ){
        this.queryTodayOrders('customer')
      }else if(i ==4 ){
        this.queryTodayOrders('amount')
      }
    },
    queryTodayOrders(t) {

      let _this = this;
      this.$request1({
        method: 'get',
        url: '/report/home/order',
        params: {
          type: t
        }
      })
        .then(response => {
          if(response.data.success){
            let carData = response.data.data;

            // 首页进来时
            if(t=='today'){
              this.cardArr = [
                carData.orderCount1,
                carData.orderCount2,
                carData.weigth.toFixed(0),
                carData.orgOwnerCount,
                carData.amount.toFixed(2)
              ];

              _this.todayData = carData
            }

            let dates = carData.chartData.map(a=>a.key);
            let countData = carData.chartData.map(a=>a.value);
            _this.initChart(dates, countData, _this.dataType[t], _this.colorType[t])
            // _this.chart.resize();
          }
          
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      this.dateTime = year + "年" + month + "月" + day + "日";
      switch (date.getDay()) {
        case 0:
          this.week = "星期天";
          break;
        case 1:
          this.week = "星期一";
          break;
        case 2:
          this.week = "星期二";
          break;
        case 3:
          this.week = "星期三";
          break;
        case 4:
          this.week = "星期四";
          break;
        case 5:
          this.week = "星期五";
          break;
        case 6:
          this.week = "星期六";
          break;
      }
    },
    queryUrgentNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/urgent'
      })
        .then(response => {
          this.noticeData = response.data;
          if (this.noticeData.length > 0) {
            this.dialogUrgentVisible = true;
          } else {
            this.noticeData = [
              {
                content: "",
                createDate: "",
                id: "",
                level: 1,
                orgOp: "",
                title: "",
                type: ""
              }
            ];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/notice',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          this.noticeTotal = response.data.total;
          this.unreadNoticeTotal = response.data.data.unreadTotal;
          this.unreadNoticeList = response.data.data.unread;
          this.readNoticeList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },

   querySystemInfo() {
      this.$request1({
        method: 'GET',
        url: '/notice/systeminfo',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
              this.systemInfoTotal = response.data.total;
              this.unreadSystemInfoTotal = response.data.data.unreadTotal;
              this.unreadSystemInfoList = response.data.data.unread;
              this.readSystemInfoList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },

    queryMessage() {
      this.$request1({
        method: 'GET',
        url: '/notice/message',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          this.messageTotal = response.data.total;
          this.unreadMessageTotal = response.data.data.unreadTotal;
          this.unreadMessageList = response.data.data.unread;
          this.readMessageList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryQuotationNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/quotation',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          this.quotationTotal = response.data.total;
          this.unreadQuotationTotal = response.data.data.unreadTotal;
          this.unreadQuotationList = response.data.data.unread;
          this.readQuotationList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkNoticeInfo(type, data) {
      this.title = "系统公告";
      if (type == "MESSAGE") {
        this.title = "最新消息";
      } else if (type == "QUOTATION") {
        this.title = "更新报价";
      }
      this.checkNotice = data;
      this.dialogNoticeVisible = true;
      if (!data.isRead) {
        this.createdReadNotice(data.id, type);
      }
    },
    createdReadNotice(noticeId, type) {
      this.$request1({
        method: 'POST',
        url: '/readNotice/create',
        params: {
          noticeId: noticeId
        }
      })
        .then(response => {
          this.dialogUrgentVisible = false;
          if (type == "MESSAGE") {
            this.queryMessage();
          } else if (type == "QUOTATION") {
            this.queryQuotationNotice();
          } else if (type == "NOTICE") {
            this.queryNotice();
          } else if (type == "SYSTEMINFO") {
            this.querySystemInfo();
          } else {
            this.queryUrgentNotice();
            this.querySystemInfo();
            this.queryNotice();
            this.queryMessage();
            this.queryQuotationNotice();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.tms-index__page {
  .box-card {
    * + * {
      margin-top: 10px;
    }
    h2 {
      font-weight: normal;
    }
    span {
      display: inline-block;
    }
    .m-t {
      margin-top: 56px;
      margin-bottom: 40px;
    }
  }
  .f-box {
    margin-bottom: 20px;
  }
  //新闻
  .news-list {
    margin-top: 15px;
    > a {
      position: relative;
      display: block;
      width: 100%;
      padding: 15px 0 15px 25px;
      border-top: 1px solid #ebeef5;
      &:first-child {
        border-top: none;
      }
      &.has-read {
        .item-title,
        .small {
          color: #676767;
        }
      }
      &.not-read {
        .item-title,
        .small {
          color: rgb(34, 34, 34);
          font-weight: 700;
        }
      }
      .download-file__btn {
        float: left;
        margin: 0 10px;
        z-index: 99;
      }
    }
    .update-price__list {
      .item-title {
        float: left;
      }
    }
    .list {
      // display: flex;
      // align-items: center;
      // padding: 15px 0;
      // & + .list {
      //   border-top: 1px solid #ebeef5;
      // }
    }
    .small {
      float: right;
      color: #888;
      font-size: 12px;
    }

    .new-gif__icon {
      position: absolute;
      top: 5px;
      left: -5px;
    }
  }

  .clearfix {
    .h2 {
      font-size: 16px;
      font-weight: bold;
      color: #666;
    }
  }

  .tips-text {
    margin-left: 10px;
    font-size: 12px;
    .number {
      margin: 0 5px;
      font-weight: 400;
    }
    .new {
      margin-left: 5px;
      color: #5fa207;
      &:link,
      &:hover,
      &:visited {
        color: #5fa207;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.update-price__list:after {
  content: "";
  display: block;
  clear: both;
}

.content-price__download {
  margin-right: 15px;
  color: rgb(64, 158, 255);
  &:hover {
    text-decoration: underline;
  }
}

.unread-item{
  position: absolute;
  top: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #F56C6C;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  font-size: 12px;
}

@media (min-width: 768px) {
}

</style>


// WEBPACK FOOTER //
// src/views/home/index.vue